/**
 * This directive is used for component testing and intended to separate quality engineering from
 * design or coding. Whenever you need to select elements from the DOM for test purposes, use this
 * directive instead of the id or class attributes.
 *
 * The directive will only be rendered in test and dev environments not to pollute production.
 *
 * @example
 * // watch out: the value must be a 'string'
 * <tag v-data-test-id="'my-id'"></tag>
 *
 * // prefer using the DATA_TEST_IDS enum:
 * <tag v-data-test-id="DATA_TEST_IDS.myId"></tag>
 *
 * // in test and dev envs, will render as:
 * <tag data-test-id="my-id"></tag>
 *
 * // in other envs, will render as:
 * <tag></tag>
 *
 */
export default (el, binding) => {
  if (!binding.value)
    throw 'v-data-test-id value must be passed as a string for: ' + binding.expression

  if (
    [process.env.NODE_ENV, process.env.TARGET_ENV].some(
      env => env === 'test' || env === 'development'
    )
  ) {
    el.setAttribute('data-test-id', binding.value)
  }
}
